<template>
  <div class="d-flex align-center ga-2">
    <v-btn
      variant="outlined"
      height="36"
      rounded="lg"
      class="download-btn"
      :loading="csvDownloadLoading"
      :disabled="libraryLoading || csvDownloadLoading || hasNoResults"
      @click="handleDownloadCsv"
    >
      <v-icon
        icon="$tray-arrow-down"
        class="mr-2"
        size="small"
      />
      Download CSV
    </v-btn>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useFlsaSurveysStore } from '@/stores/jobProfiles/flsaSurveys';

defineProps({
  libraryLoading: { type: Boolean, default: false },
});

const route = useRoute();
const { profiles, csvDownloadLoading } = storeToRefs(useFlsaSurveysStore());
const { downloadCsv } = useFlsaSurveysStore();

const hasNoResults = computed(() => !profiles.value?.length);

const handleDownloadCsv = () => {
  downloadCsv(route.query);
};
</script>

<style lang="less" scoped>
.download-btn {
  border: 1px solid @stroke-default;
  color: @text-dark;
  background: @white;
}
</style>
